package com.macrofocus.eflux.data.quest

import com.macrofocus.eflux.data.ZonePowerFlowRecord
import org.molap.dataframe.DataFrame

class QuestZonePowerFlowRecord(private val dataFrame: DataFrame<Int,String,Any?>, private val row: Int, private val suffix: String = "") :
    ZonePowerFlowRecord {
    override val i: Int
        get() = (dataFrame.getValueAt(row, "i$suffix") as Number).toInt()
    override val zoname: String
        get() = dataFrame.getValueAt(row, "zoname$suffix") as String
}